import { ApiError } from "@vana/core";

export class ListCoverageError extends ApiError {}

export class UpdateZoneError extends ApiError {}

export class AddZoneError extends ApiError {}
